/**
 * Master list of resource categories / tags.
 * This is the single source of truth - the admin ResourceEditorPage
 * uses CATEGORY_NAMES for both the category dropdown and the tag selector.
 * ResourcesPage and ResourceDetailPage derive colours from CATEGORY_COLOR_MAP.
 */
export const RESOURCE_CATEGORIES = [
  { name: 'Process Guides',   color: '#0ea5e9' },
  { name: 'How-To Guides',    color: '#8b5cf6' },
  { name: 'Sales Enablement', color: '#16a34a' },
  { name: 'Email Templates',  color: '#ea580c' },
  { name: 'Marketing',        color: '#d97706' },
  { name: 'Internal Guides',  color: '#64748b' },
];

/** Plain array of names - used in the admin editor */
export const CATEGORY_NAMES = RESOURCE_CATEGORIES.map(c => c.name);

/** name → hex colour lookup - used for tag pills on cards and detail page */
export const CATEGORY_COLOR_MAP = Object.fromEntries(
  RESOURCE_CATEGORIES.map(c => [c.name, c.color])
);
